import React, { useCallback } from 'react';
import { Tappable } from '@vectord/components';
import { useDispatch, batch } from 'react-redux';

import {
  CANCEL_PAUSE_REQUEST_MODAL_STAGES,
  setCancelRequestModalStage,
  setSelectedRequest,
} from 'features/courseResume';

function CancelButton({ request }) {
  const dispatch = useDispatch();

  const handleCancel = useCallback(() => {
    batch(() => {
      dispatch(setSelectedRequest(request));
      dispatch(
        setCancelRequestModalStage(CANCEL_PAUSE_REQUEST_MODAL_STAGES.confirm)
      );
    });
  }, [dispatch, request]);

  return (
    <Tappable
      onClick={handleCancel}
      className="primary bold btn-small"
      noHighlight
    >
      Cancel
    </Tappable>
  );
}

export default CancelButton;
